import { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { getRcmServiceForCategory, RCM_SERVICE_HINT } from '../../../../utils/helpers/rcmEligibility';

/**
 * RCM Applicable dropdown, locked to "No" unless the selected vendor category is one of the
 * notified reverse-charge services. Reads `category` / `rcmApplicable` off the Formik form.
 */
const RcmApplicableField = ({ categories, className }) => {
    const { values, setFieldValue } = useFormikContext();

    const categoriesLoaded = Array.isArray(categories) && categories.length > 0;
    const category = (categories || []).find(cat => String(cat.category_id ?? cat.id) === String(values.category));
    const rcmService = getRcmServiceForCategory(category?.label ?? category?.name ?? category?.category_name);
    const allowed = Boolean(rcmService);

    // Switching to a non-notified category (or loading a vendor saved before this rule) must not
    // leave a stale "Yes" behind — the disabled dropdown would otherwise submit it silently.
    useEffect(() => {
        if (categoriesLoaded && !allowed && values.rcmApplicable !== 'N') {
            setFieldValue('rcmApplicable', 'N');
        }
    }, [categoriesLoaded, allowed, values.rcmApplicable, setFieldValue]);

    return (
        <div>
            <label className="tw-text-xs tw-font-medium tw-text-gray-600 tw-mb-1 tw-block">RCM Applicable</label>
            <Field
                as="select"
                name="rcmApplicable"
                disabled={!allowed}
                className={className}
            >
                <option value="N">No</option>
                <option value="Y">Yes</option>
            </Field>
            <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
                {allowed
                    ? `Reverse charge can apply to ${rcmService.label}.`
                    : `Available only for notified reverse-charge services (${RCM_SERVICE_HINT}).`}
            </p>
        </div>
    );
};

export default RcmApplicableField;
